import React, { createContext, useState } from 'react';



export const ChatbotContext = createContext();

export const ChatbotProvider = ({ children }) => {
  const [showFabChat, setShowFabChat] = useState(true)
  const [chatPosition, setChatPosition] = useState({x:0, y:0})

  return (
    <ChatbotContext.Provider value={{ 
      showFabChat, setShowFabChat, chatPosition, setChatPosition
    }}>
      {children}
    </ChatbotContext.Provider>
  );
};